<ion-item class="form-element-wrapper" fill="outline" mode="md">
  <ion-label position="floating">{{ label }}</ion-label>
  <ion-input type="number" [formControl]="formCtrl" [min]="min" [max]="max" [required]="required" mode="ios" (keyup.enter)="keyupEnter.emit()"></ion-input>
  <mom-validation-text slot="error" [formCtrl]="formCtrl"></mom-validation-text>
  <ion-note *ngIf="helper" slot="helper">{{ helper }}</ion-note>
</ion-item>
